// components/admin-dashboard/charts/ChartCard.js
import React from 'react';
import { RefreshCcw } from "lucide-react";
import PropTypes from 'prop-types';

const ShimmerEffect = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 dark:bg-gray-700 ${className}`} />
);

export const ChartCard = ({ 
  title, 
  children, 
  icon: Icon, 
  isLoading = false, 
  error = null,
  className = '',
  color = '#003087',
  height = '300px'
}) => {
  const containerClasses = `bg-white dark:bg-slate-900 rounded-lg shadow border border-gray-200 dark:border-gray-800 p-6 ${className}`.trim();
  
  const renderContent = () => {
    if (error) {
      return (
        <div className="flex flex-col items-center justify-center h-[300px] text-center">
          <p className="text-red-500 dark:text-red-400 mb-2">Error loading chart</p>
          <p className="text-sm text-gray-500 dark:text-gray-400">{error}</p>
        </div>
      );
    }

    if (isLoading) {
      return <ShimmerEffect className={`h-[${height}] rounded`} />;
    }

    return children;
  };

  return (
    <div className={containerClasses}>
      <div className="flex justify-between items-center mb-6">
        <div className="flex items-center space-x-2">
          {Icon && <Icon className="h-5 w-5" style={{ color }} />}
          {title && <h2 className="text-lg font-medium text-gray-900 dark:text-white">{title}</h2>}
        </div>
        {isLoading && <RefreshCcw className="h-5 w-5 animate-spin text-gray-400 dark:text-gray-500" />}
      </div>
      {renderContent()}
    </div>
  );
};

ChartCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.elementType,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.string
};

export default ChartCard;